var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { ref: "modal", attrs: { modalId: "contractor-data-" + +new Date() } },
    [
      _vm.allVendorsIntegrated
        ? _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
            _c(
              "label",
              {
                staticClass: "header",
                attrs: { for: "tender.general.contractData" },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("hint.whatWeFound")) + "\n    "
                ),
              ]
            ),
          ])
        : _c(
            "p",
            {
              staticClass: "modal-header",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("hint.missingVendorData")) + ":\n  "
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-bg",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _vm.allVendorsIntegrated
            ? [
                _c("div", { staticClass: "pr-info-label" }, [
                  _c("label", { attrs: { for: "tender.general.budget" } }, [
                    _vm._v(_vm._s(_vm.$t("tender.general.prNumber")) + ":"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "pr-info",
                      attrs: { id: "tender.general.budget" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.contractData.number) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.contractData.description,
                        expression: "contractData.description",
                      },
                    ],
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "pr-info",
                        attrs: { id: "tender.general.budget" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.contractData.description) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pr-info-label" }, [
                  _c("label", { attrs: { for: "tender.general.budget" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("tender.general.estimatedBudget")) + ":"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "pr-info",
                      attrs: { id: "tender.general.budget" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("formatCurrency")(_vm.contractData.budget, {
                              currencyCode: _vm.contractData.currencyCode,
                            })
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pr-info-label" }, [
                  _c("label", { attrs: { for: "tender.general.site" } }, [
                    _vm._v(_vm._s(_vm.$t("tender.general.siteId")) + ":"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "pr-info",
                      attrs: { id: "tender.general.site" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.contractData.siteId || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pr-info-label" }, [
                  _c("label", { attrs: { for: "tender.general.vendors" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("tender.general.vendors")) +
                        " (" +
                        _vm._s(_vm.totalVendorCount) +
                        "):"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.contractData.vendors, function (vendorAccount) {
                    return _c("li", { key: vendorAccount.id }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.deep(vendorAccount, "name") || "") +
                          "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "error-hint-msg",
                    attrs: { id: "tender.general.budget" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("hint.missingVendorOperation")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._l(
                  Object.keys(_vm.contractData.vendors || {}),
                  function (vendorId) {
                    return !_vm.deep(_vm.contractData, "vendors." + vendorId)
                      ? _c("div", { key: vendorId }, [
                          _c(
                            "div",
                            {
                              staticClass: "error-hint-msg",
                              attrs: { id: "tender.general.budget" },
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(vendorId) + "\n        "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e()
                  }
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _vm.allVendorsIntegrated
          ? _c(
              "div",
              {
                staticClass: "dialog-btn row align-right nav_btn",
                attrs: { slot: "btns" },
                slot: "btns",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue button-margin",
                    attrs: { id: "tender.general.contractData.cancel" },
                    on: { click: _vm.cleanContractData },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.goback")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange button-margin",
                    attrs: { id: "tender.general.contractData.save" },
                    on: { click: _vm.setContractData },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.yesThatsit")))]
                ),
              ]
            )
          : _c("div", { staticClass: "row align-center nav_btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue button-margin",
                  attrs: { id: "tender.general.contractData.cancel" },
                  on: { click: _vm.cleanContractData },
                },
                [_vm._v(_vm._s(_vm.$t("hint.okay")))]
              ),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }